import { render, staticRenderFns } from "./Sinistro.vue?vue&type=template&id=39c9ee84"
import script from "./Sinistro.vue?vue&type=script&lang=js"
export * from "./Sinistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports